<template>
  <div class="config-manage">
    <page-header title="参数配置" :count="total">
      <template #actions>
        <el-button type="success" size="small" icon="el-icon-plus" @click="openDialog(null)">新增配置</el-button>
      </template>
      <el-select v-model="filterCategory" placeholder="全部分类" clearable size="small">
        <el-option label="全部" value="" />
        <el-option label="基础配置" value="BASIC" />
        <el-option label="H5前端" value="H5" />
        <el-option label="系统参数" value="SYSTEM" />
      </el-select>
      <el-input v-model="keyword" class="ph-search" placeholder="搜索配置键/说明" clearable size="small"
        @keyup.enter.native="loadList" />
      <el-button type="primary" size="small" icon="el-icon-search" @click="loadList">搜索</el-button>
    </page-header>

    <!-- 配置列表 -->
    <el-table :data="pagedList" v-loading="loading" stripe border size="small" class="app-table" style="width: 100%">
      <el-table-column prop="configKey" label="配置键" width="180" show-overflow-tooltip />
      <el-table-column prop="description" label="说明" min-width="160" show-overflow-tooltip />
      <el-table-column prop="category" label="分类" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="categoryTag(row.category)">{{ categoryLabel(row.category) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="valueType" label="值类型" width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{ typeLabel(row.valueType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="configValue" label="配置值" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.valueType === 'RICHTEXT'" class="value-preview">[富文本内容，请点击编辑查看]</span>
          <span v-else>{{ row.configValue || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 (前端切片) -->
    <div class="app-pagination" v-if="total > pageSize">
      <el-pagination background layout="prev, pager, next, total" :total="total"
        :page-size="pageSize" :current-page.sync="currentPage" />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editForm.id ? '编辑配置' : '新增配置'" :visible.sync="dialogVisible" width="680px" append-to-body>
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editFormRef">
        <el-form-item label="配置键" prop="configKey">
          <el-input v-model="editForm.configKey" placeholder="如 about_us、contact_phone" :disabled="!!editForm.id" />
        </el-form-item>
        <el-form-item label="说明" prop="description">
          <el-input v-model="editForm.description" placeholder="配置项中文说明" />
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="editForm.category" style="width:100%" :popper-append-to-body="false">
            <el-option label="基础配置" value="BASIC" />
            <el-option label="H5前端" value="H5" />
            <el-option label="系统参数" value="SYSTEM" />
          </el-select>
        </el-form-item>
        <el-form-item label="值类型">
          <el-select v-model="editForm.valueType" style="width:100%" :popper-append-to-body="false">
            <el-option label="单行文本" value="TEXT" />
            <el-option label="多行文本" value="TEXTAREA" />
            <el-option label="富文本(HTML)" value="RICHTEXT" />
            <el-option label="图片链接" value="IMAGE" />
            <el-option label="数字" value="NUMBER" />
            <el-option label="开关(布尔)" value="BOOLEAN" />
          </el-select>
        </el-form-item>
        <el-form-item label="配置值" prop="configValue">
          <el-input v-if="editForm.valueType === 'TEXT' || editForm.valueType === 'IMAGE' || editForm.valueType === 'NUMBER'" v-model="editForm.configValue" placeholder="请输入配置值" />
          <el-input v-else-if="editForm.valueType === 'TEXTAREA'" v-model="editForm.configValue" type="textarea" :rows="4" placeholder="请输入配置内容" />
          <div v-else-if="editForm.valueType === 'RICHTEXT'" class="editor-wrapper">
            <quill-editor ref="myQuillEditor" v-model="editForm.configValue" :options="editorOption" class="config-editor" />
          </div>
          <el-switch v-else-if="editForm.valueType === 'BOOLEAN'" v-model="boolValue" active-text="是" inactive-text="否" />
          <el-input v-else v-model="editForm.configValue" placeholder="请输入配置值" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.sortOrder" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="statusValue" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import baseUrl from '@/request/config.js';

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'ConfigManage',
  components: { quillEditor, PageHeader },
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      saving: false,
      dialogVisible: false,
      filterCategory: '',
      keyword: '',
      editForm: {
        id: null,
        configKey: '',
        configValue: '',
        category: 'BASIC',
        description: '',
        valueType: 'TEXT',
        sortOrder: 0,
        status: 1
      },
      rules: {
        configKey: [{ required: true, message: '请输入配置键', trigger: 'blur' }]
      },
      editorOption: {
        placeholder: '请输入富文本内容...',
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ align: [] }],
            ['blockquote', 'code-block'],
            ['link', 'image'],
            ['clean']
          ]
        }
      }
    };
  },
  computed: {
    pagedList() {
      const from = (this.currentPage - 1) * this.pageSize;
      return this.list.slice(from, from + this.pageSize);
    },
    boolValue: {
      get() { return this.editForm.configValue === 'true'; },
      set(val) { this.editForm.configValue = val ? 'true' : 'false'; }
    },
    statusValue: {
      get() { return this.editForm.status === 1; },
      set(val) { this.editForm.status = val ? 1 : 0; }
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const token = JSON.parse(localStorage.getItem('token') || '{}');
        const res = await axios.get(`${baseUrl}/api/config/list`, {
          headers: { token: token.token },
          params: { category: this.filterCategory, keyword: this.keyword }
        });
        if (res.data.code === 200) {
          this.list = res.data.data || [];
          this.total = this.list.length;
        }
      } catch (e) {
        console.error('加载配置列表失败', e);
      }
      this.loading = false;
    },

    openDialog(row) {
      if (row) {
        this.editForm = { ...row };
      } else {
        this.editForm = {
          id: null, configKey: '', configValue: '', category: 'BASIC',
          description: '', valueType: 'TEXT', sortOrder: 0, status: 1
        };
      }
      this.dialogVisible = true;
    },

    async handleSave() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const token = JSON.parse(localStorage.getItem('token') || '{}');
          const res = await axios.post(`${baseUrl}/api/config/save`, this.editForm, {
            headers: { token: token.token }
          });
          if (res.data.code === 200) {
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        } catch (e) {
          this.$message.error('保存失败');
        }
        this.saving = false;
      });
    },

    handleDelete(row) {
      this.$confirm(`确定删除配置"${row.configKey}"？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const token = JSON.parse(localStorage.getItem('token') || '{}');
          const res = await axios.delete(`${baseUrl}/api/config/${row.id}`, {
            headers: { token: token.token }
          });
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            this.loadList();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        } catch (e) {
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },

    categoryLabel(cat) {
      const map = { BASIC: '基础', H5: 'H5前端', SYSTEM: '系统' };
      return map[cat] || cat;
    },

    categoryTag(cat) {
      const map = { BASIC: '', H5: 'success', SYSTEM: 'warning' };
      return map[cat] || 'info';
    },

    typeLabel(type) {
      const map = { TEXT: '文本', TEXTAREA: '多行', RICHTEXT: '富文本', IMAGE: '图片', NUMBER: '数字', BOOLEAN: '开关' };
      return map[type] || type;
    }
  }
};
</script>

<style lang="scss" scoped>
.config-manage {
  padding: 24px;
  height: 100%;
  overflow-y: auto;
}

/* .page-header 已抽到 PageHeader 组件 */

.value-preview {
  font-size: 12px;
  color: #909399;
  :deep(h2), :deep(h3), :deep(p) {
    margin: 0;
    display: inline;
  }
}
</style>

<style lang="scss">
.editor-wrapper {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  line-height: normal;
}
.config-editor {
  .ql-editor {
    min-height: 200px;
    max-height: 400px;
    overflow-y: auto;
    font-size: 14px;
  }
  .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid #e4e7ed;
    background: #fafafa;
  }
  .ql-container.ql-snow {
    border: none;
  }
}
</style>
